import { render, staticRenderFns } from "./RowColumn.vue?vue&type=template&id=3e58c1e0&scoped=true&"
import script from "./RowColumn.vue?vue&type=script&lang=js&"
export * from "./RowColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e58c1e0",
  null
  
)

export default component.exports